
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-670d434f&scoped=true!sass-loader!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./commonQuestion.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./commonQuestion.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-670d434f!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./commonQuestion.vue"),
  /* scopeId */
  "data-v-670d434f",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/ProductDocument/components/commonQuestion.vue
// module id = 389
// module chunks = 0